var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"a-required-icon",class:{ 'a-required-icon--valid': _vm.valid }},[(_vm.valid)?_c('i',{staticClass:"crevo-icon crevo-check"}):_vm._e(),(!_vm.valid)?_c('span',[_vm._v(_vm._s(_vm.$t('atoms.required')))]):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }